<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Számlaszámok</span>
      <el-button
        style="float: right; margin-top: -8px;"
        type="success"
        size="small"
        @click="onCreate"
        icon="el-icon-plus"
      >
        Új számlaszám
      </el-button>
    </div>
    <el-alert
      v-if="!accounts || !accounts.length"
      title="Ehhez a partnerhez még nem tartozik számlaszám. Adj hozzá egyet."
      type="info"
      show-icon
      :closable="false"
    />
    <el-alert
      v-if="accounts && accounts.length && !accounts.find(acc => acc.is_primary)"
      title="Nincs kiválasztva elsődleges számlaszám."
      type="warning"
      show-icon
      :closable="false"
    />
    <el-table
      v-if="accounts && accounts.length"
      :data="accounts"
    >
      <el-table-column
        prop="bank"
        label="Bank"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.bank }}
          <el-tag size="small" v-if="scope.row.is_primary" style="margin-left: 5px;">Elsődleges</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="value"
        label="Számlaszám"
        show-overflow-tooltip
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot-scope="scope"
        >
          <account-actions
            :account="scope.row"
            @update="onUpdate"
            @delete="onDelete"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible="showDialog"
      :title="accountFormType === 'add' ? 'Új számlaszám' : 'Számlaszám módosítás'"
      @close="onClose"
      append-to-body
      :close-on-click-modal="false"
      width="550px"
    >
      <account-form ref="accountForm"
        :defaultAccount="selectedAccount"
        :formType="accountFormType" />
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="onClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          @click="storeAccounts"
        >
          {{ accountFormType === 'add' ? 'Hozzáadás' : 'Módosítás' }}
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
  import AccountForm from './BankAccount';
  import AccountActions from './AccountActions';

  export default {
    components: {
      AccountForm,
      AccountActions
    },
    props: ['accounts'],
    data() {
      return {
        showDialog: false,
        accountFormType: 'add',
        selectedAccount: {},
      };
    },
    methods: {
      onClose() {
        this.$refs.accountForm.account = {};
        this.showDialog = false;
        this.$refs.accountForm.$refs.accountForm.resetFields();
      },
      onCreate() {
        this.accountFormType = 'add';
        this.showDialog = true;
      },
      onUpdate(account) {
        this.selectedAccount = Object.assign({}, account);
        this.accountFormType = 'update';
        this.showDialog = true;
      },
      onDelete(account) {
        const accounts = this.accounts.filter(a => ((a.id && a.id !== account.id) || a.key !== account.key));
        this.$emit('change', accounts);
      },
      async storeAccounts() {
        const account = Object.assign({}, this.$refs.accountForm.account);
        this.$refs['accountForm'].$refs['accountForm'].validate(valid => {
          if (valid) {
            if (this.accountFormType === 'add') {
              const newAccount ={
                ...account,
                key: Math.random().toString(36).substring(7),
              };
              this.$emit('add', newAccount);
            } else {
              const accounts = this.accounts.map(a => {
                if ((a.id && a.id === account.id) || (a.key && a.key === account.key)) {
                  return account;
                } else {
                  if (a.is_primary && account.is_primary) {
                    return {
                      ...a,
                      is_primary: false,
                    };
                  } else {
                    return a;
                  }
                }
              });
              this.$emit('change', accounts);
            }
            this.showDialog = false;
          }
        });
      },
    },
  };
</script>
